module.exports = __webpack_public_path__ + "static/img/h-7.4708e3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/h-7.jpg
// module id = mfjJ
// module chunks = 1